var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9935 1.33325C4.3135 1.33325 1.3335 4.31992 1.3335 7.99992C1.3335 11.6799 4.3135 14.6666 7.9935 14.6666C11.6802 14.6666 14.6668 11.6799 14.6668 7.99992C14.6668 4.31992 11.6802 1.33325 7.9935 1.33325ZM8.00016 13.3333C5.0535 13.3333 2.66683 10.9466 2.66683 7.99992C2.66683 5.05325 5.0535 2.66659 8.00016 2.66659C10.9468 2.66659 13.3335 5.05325 13.3335 7.99992C13.3335 10.9466 10.9468 13.3333 8.00016 13.3333ZM7.3335 8.71325L10.9935 10.9066L11.6735 9.75992L8.66683 7.95325V4.27992H7.3335V8.71325Z",
    fill: "inherit"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.1e4b92a2f61da6a3f2e5bd6e10f1b4ec.svg";
export { ForwardRef as ReactComponent };